export default {
  getLastLessons(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/students/last-lessons")
        .then(response => {
          context.commit("setLastLessons", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  setProgress(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/students/progress", data)
        .then(resolve)
        .catch(reject);
    });
  }
};
